// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectAlgorithmMessageBase } from './DirectAlgorithmMessageBase';
import { Message } from '../Message';
export class DirectAlgorithmGainersLosersMessage extends DirectAlgorithmMessageBase {
    constructor() {
        super(Message.CODE_PFIX_ALGORITHM_GAINERS_LOSERS_MESSAGE);
        this.GainersLosersData = [];
    }
}
